import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { LoaderFull } from '../../Loader';

const SitesIssueForm = ({
    companyName,
    documentNumber,
    userName,
    clientEmail,
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [URL, setURL] = useState('');

    const generateTicketCode = () => {
        const date = new Date();
        const randomNumber = Math.round(Math.random() * (9999 - 1000) + 1000);
        const month = `0${date.getMonth() + 1}`.slice(-2);
        return `C${date.getFullYear()}${month}${date.getDate()}-${randomNumber}`;
    };

    useEffect(() => {
        setURL(`https://ticket-builder-pro.lovable.app?nomeempresa=${companyName}&cnpj=${documentNumber}&numerochamado=${generateTicketCode()}&nomeusuario=${userName}&emailcliente=${clientEmail}`);
    }, []);

    const iframeRef = useRef({
        current: {},
    });

    const style = {
        width: '100%',
        display: isLoading ? 'none' : 'block',
    };

    // function to get iframe doc height
	const getIframeDocHeight = (doc) => {
		doc = doc || document;
		const body = doc.body;
        const html = doc.documentElement;
		const height = Math.max(
			body.scrollHeight,
			body.offsetHeight,
			html.clientHeight,
			html.scrollHeight,
			html.offsetHeight,
        );
		return height > 949 ? height + 100 : 1100;
	};

    const onIframeLoad = () => {
		// We set iframe height dynamically based on iframe doc height
		const ifrm = iframeRef.current;
        const doc = ifrm.contentDocument && ifrm.contentDocument;
        ifrm.style.height = `${getIframeDocHeight(doc)}px`;
        setIsLoading(false);
    };

    return (
	<>
		{isLoading && <LoaderFull />}
		<iframe
			ref={iframeRef}
			src={URL}
			style={style}
			id="Iframe-TicketBuilder"
			title="Formulário de Abertura de Chamados"
			onLoad={onIframeLoad}
			allowTransparency="true"
			allowFullScreen="true"
			allow="geolocation; microphone; camera"
			frameBorder="0"
			scrolling="no"
		/>
	</>
    );
};

PropTypes.SitesIssueForm = {
    companyName: PropTypes.string,
    documentNumber: PropTypes.string,
    userName: PropTypes.string,
    clientEmail: PropTypes.string,
};

export default SitesIssueForm;
